import axios from "axios";
import { BASE_API_URL, BASE_API_URL_Local } from "./const";

let conf = {
  headers: {
    Accept: "*",
    "Content-Type": "application/json"
  }
};

if (process.env.NODE_ENV !== "development") {
  // conf.baseURL = process.env.VUE_APP_API_URL || BASE_API_URL;
  conf.baseURL = BASE_API_URL;
} else {
  conf.baseURL = BASE_API_URL_Local;
}

export default axios.create(conf);
